// Helper Functions

const id = (it) => it;
const vh = (pct) => (pct / 100) * window.innerHeight;
const log = (...args) => console.log.apply(console, args);
const head = (list) => list.length ? list[0] : null;
const wrap = (a, b, n) => n < a ? b : n > b ? a : n;
const lerp = (t, a, b) => a + t * (b - a);
const flip = (λ) => (a, b) => λ(b, a);
const limit = (min, max, n) => n < min ? min : n > max ? max : n;
const tween = (s, e, d, λs, λc = id) => $({ x: s }).animate({ x: e }, { duration: d, complete: λc, step: function() { λs(this.x); } });
const padTwo = (str) => str.length < 2 ? "0" + str : str;
const percent = (val) => (val * 100) + '%';
const contains = (list, needle) => list.indexOf(needle) > -1;
const keyMatch = (key, λ) => ({ which }) => which === key ? λ() : undefined;
const randRange = (min, max) => min + (max - min) * Math.random();
const randomFrom = (xs) => xs[Math.floor(randRange(0, xs.length))];
const searchWithin = ($target) => (sel) => $(sel, $target);


// Derived functions

const delay = flip(setTimeout);
const defer = delay(0);


// JQuery shims, etc

const jqm = (λ) => (ix, el) => λ($(el), ix);


// Export math functions

const pi = Math.PI;
const tau = Math.PI * 2;
const min = Math.min;
const max = Math.max;
const abs = Math.abs;
const sin = Math.sin;
const cos = Math.cos;
const floor = Math.floor;
const round = Math.round;


// Special Domain Functions

const looksLikeMethodDropdown = (options) => options[0] === 'Salted' || options[0] === 'Tubed';
const looksLikeLengthDropdown = (options) => 'm' === options[0].substr(-1, 1);

const getDropdownType = ($target) => {
  const options = $($target).children().toArray().map(el => el.value);
  if (looksLikeMethodDropdown(options)) return 'method';
  if (looksLikeLengthDropdown(options)) return 'length';
  console.warn("Unknown dropdown: " + $target.data('option'));
};

const formatDollars = (value) => {
  const [dollars, rem] = String(value).split('.');
  let cents;
  if (!rem) {
    cents = '00';
  } else if (rem.length === 1) {
    cents = rem + '0';
  } else {
    cents = rem;
  }
  return dollars + '.' + cents;
};

const swallow = (λ) => (event) => {
  event.preventDefault();
  λ();
};

module.exports = {
  id, vh, log, head, wrap, lerp, flip, limit, tween, padTwo, percent, contains, keyMatch, randRange, randomFrom, searchWithin,
  delay, defer, jqm,
  pi, tau, min, max, abs, sin, cos, floor, round,
  getDropdownType, formatDollars, swallow
};
